import { useTranslation } from 'react-i18next';

import { getDateLocale } from './dateLocales';

const useDateLocale = (): ReturnType<typeof getDateLocale> => {
  const { i18n } = useTranslation();

  return getDateLocale(i18n.language);
};

export default useDateLocale;
